<template>
  <div
    class="lv-outage-content"
    :class="{
      'lv-outage-content--list-view': outagePageView === 'list',
    }"
  >
    <template v-if="filterOption != 'lv'">
      <span
        class="lv-outage-content__content"
        v-html="lvOutageHVContent"
      ></span>
      <a class="lv-outage-content__link" href="#" @click.prevent="toggleLvTab"
        >individual outages by suburb.</a
      ></template
    >
    <template v-else>
      <span v-html="lvOutageLVContent"></span>
      <br />
      <table class="lv-outage-content__table">
        <tr>
          <td>Total open incidents:</td>
          <td>&nbsp;{{ calcTotalOpenIncidents }}</td>
        </tr>
        <tr class="lv-outage-content__tr--line">
          <td>Total closed incidents:</td>
          <td>&nbsp;{{ calcTotalClosedIncidents }}</td>
        </tr>
        <tr>
          <td>Total overall incidents:</td>
          <td>&nbsp;{{ calcTotalOpenIncidents + calcTotalClosedIncidents }}</td>
        </tr>
      </table>
    </template>

    <div
      class="c-outages-search__information"
      v-if="lvOutageSelectedLocation != null"
    >
      <span class="c-outages-search__results"
        >{{ getFilteredLVOutagesGeoJson.length }} of
        {{ getLVOutagesGeoJson.length }} results showing
      </span>
      <span @click="clearAllFilters" class="c-outages-search__clear"
        >CLEAR
      </span>
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import { mapGetters } from "vuex";

export default {
  created() {},
  components: {},
  mounted() {},
  computed: {
    ...mapFields([
      "filterOption",
      "lvOutageHVContent",
      "lvOutageLVContent",
      "outagePageView",
      "lvOutageSelectedLocation",
    ]),
    ...mapGetters(["getFilteredLVOutagesGeoJson", "getLVOutagesGeoJson"]),
    calcTotalOpenIncidents() {
      return this.getLVOutagesGeoJson.reduce((total, feature) => {
        return total + Number(feature.properties.csvTotalOpenIncidents);
      }, 0);
    },
    calcTotalClosedIncidents() {
      return this.getLVOutagesGeoJson.reduce((total, feature) => {
        return total + Number(feature.properties.csvTotalClosedIncidents);
      }, 0);
    },
  },
  methods: {
    clearAllFilters() {
      this.$store.commit("clearAllFilters");
      this.$store.commit("resetMapView");
    },
    toggleLvTab() {
      this.filterOption = "lv";
    },
  },
};
</script>

<style lang="scss"></style>
